export const Logo = ({ className = "w-12 h-12" }) => {
  return (
    <div className={`relative ${className}`}>
      <img
        src="/shebeka_logo.png"
        alt="Shebeka Logo"
        className="w-full h-full object-contain dark:hidden"
      />
      <img
        src="/shebeka_logo_dark.png"
        alt="Shebeka Logo"
        className="w-full h-full object-contain hidden dark:block"
      />
    </div>
  );
};
